import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ListRecommendationsResponse,
  Recommendation
} from '../types/apiGeneratedTypes';

export interface RecommendationsPageState {
  searchValue: string;
  appliedFilters: string[];
  isAddRecommendationModalOpened: boolean;
  recommendationsList: ListRecommendationsResponse | null;
  limit: number;
  recommendationsCount: number | null;
  isDeleteRecommendationModalOpened: boolean;
  recommendationToDelete: Recommendation | null;
  recommendationToEdit: Recommendation | null;
  recommendationToView: Recommendation | null;
  changeDeleteRecommendationModalVisibility: boolean;
  changeCreateRecommendationModalVisibility: boolean;
  memberRecommendations: ListRecommendationsResponse | null;
}

export const initialState: RecommendationsPageState = {
  searchValue: '',
  appliedFilters: [],
  isAddRecommendationModalOpened: false,
  recommendationsList: null,
  limit: 10,
  recommendationToEdit: null,
  recommendationToView: null,
  recommendationsCount: null,
  isDeleteRecommendationModalOpened: false,
  recommendationToDelete: null,
  changeDeleteRecommendationModalVisibility: false,
  changeCreateRecommendationModalVisibility: false,
  memberRecommendations: null
};

const recommendationsPageSlice = createSlice({
  name: 'recommendations',
  initialState,
  reducers: {
    changeCreateRecommendationModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.changeCreateRecommendationModalVisibility = action.payload;
    },
    changeDeleteRecommendationModalVisibility(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isDeleteRecommendationModalOpened = action.payload;
    },
    setRecommendationToEdit(
      state,
      action: PayloadAction<Recommendation | null>
    ) {
      state.recommendationToEdit = action.payload;
    },
    setRecommendationToDelete(
      state,
      action: PayloadAction<Recommendation | null>
    ) {
      state.recommendationToDelete = action.payload;
    },
    setRecommendationToView(
      state,
      action: PayloadAction<Recommendation | null>
    ) {
      state.recommendationToView = action.payload;
    },
    setRecommendationsPageSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    clearRecommendationsPageSearchValue(state) {
      state.searchValue = '';
    },
    addFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = [...state.appliedFilters, action.payload];
    },
    deleteFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = state.appliedFilters.filter(
        (el) => el !== action.payload
      );
    },
    clearAllFilters(state) {
      state.appliedFilters = [];
    },
    changeModalVisibility(state, action: PayloadAction<boolean>) {
      state.isAddRecommendationModalOpened = action.payload;
    },
    setRecommendationsList(
      state,
      action: PayloadAction<ListRecommendationsResponse>
    ) {
      state.recommendationsList = action.payload;
    },
    setMemberRecommendations(
      state,
      action: PayloadAction<ListRecommendationsResponse>
    ) {
      state.memberRecommendations = action.payload;
    },
    setRecommendationsCount(state, action: PayloadAction<number>) {
      state.recommendationsCount = action.payload;
    },
    appendRecommendationsList(
      state,
      action: PayloadAction<ListRecommendationsResponse>
    ) {
      if (state.recommendationsList) {
        state.recommendationsList = {
          ...state.recommendationsList,
          recommendations: [
            ...state.recommendationsList.recommendations,
            ...action.payload.recommendations
          ]
        };
      }
    }
  }
});

export const {
  setRecommendationsPageSearchValue,
  clearRecommendationsPageSearchValue,
  addFilter,
  deleteFilter,
  clearAllFilters,
  changeModalVisibility,
  setRecommendationsList,
  appendRecommendationsList,
  setRecommendationToEdit,
  setRecommendationToDelete,
  setRecommendationsCount,
  changeDeleteRecommendationModalVisibility,
  changeCreateRecommendationModalVisibility,
  setMemberRecommendations,
  setRecommendationToView
} = recommendationsPageSlice.actions;
export default recommendationsPageSlice.reducer;
